<template>
  <div>
    <van-tabs
      v-model="tabIndex"
      @click="tabClick"
      sticky
      swipeable
      :offset-top="300"
    >
      <van-tab title="待使用"></van-tab>
      <van-tab title="全部"></van-tab>
      <van-tab title="待付款"></van-tab>
    </van-tabs>

    <no-data
      v-if="dataLoaded && orders.length === 0"
      :content-height="contentHeight"
    ></no-data>
    <van-list
      v-else
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      class="dataDiv"
    >
      <van-cell-group class="list-box">
        <van-cell
          v-for="(order, x) in orders"
          :key="x"
          @click="onShowOrderInfo(order.listNo)"
        >
          <div class="list-item-icon"></div>
          <div class="list-item-body">
            <div class="list-item-title z4 fz14">
              订单编号: {{ order.listNo }}
            </div>
            <ul>
              <li>
                <div class="ul-li-label z4 fz13">使用时间</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">
                  {{ order.travelDate }}
                </div>
              </li>
              <li>
                <div class="ul-li-label z4 fz13">游客人数</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">{{ order.totalNum }}</div>
              </li>
              <li v-if="order.totalMoney > 0">
                <div class="ul-li-label z4 fz13">总 价</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">
                  ¥ {{ order.totalMoney.toFixed(2) }}
                </div>
              </li>
            </ul>
            <div class="list-item-status fz16" :class="order.status">
              {{ order.orderStatusName }}
            </div>
          </div>
        </van-cell>
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import orderService from "@/services/orderService.js";
import NoData from "@/components/NoData.vue";

export default {
  components: {
    NoData,
  },
  data() {
    return {
      scrollTop: 0,
      loading: false,
      dataLoaded: false,
      finished: false,
      tabIndex: 0,
      queryInput: {
        isNotPaid: "",
        used: "",
        skipCount: 0,
        maxResultCount: 20,
      },
      orders: [],
    };
  },
  computed: {
    contentHeight() {
      return this.$store.state.clientHeight - 150;
    },
  },
  methods: {
    async tabClick(index) {
      this.tabIndex = index;
      this.queryInput.skipCount = 0;
      this.orders = [];
      await this.getOrders();
    },
    async onLoad() {
      await this.getOrders();
    },
    onShowOrderInfo(listNo) {
      this.$router.push({
        name: "orderinfo",
        params: { listNo: listNo },
      });
    },
    async getOrders() {
      try {
        this.loading = true;
        this.dataLoaded = false;

        this.queryInput.used = this.tabIndex === 0 ? "true" : "";
        this.queryInput.isNotPaid = this.tabIndex === 2 ? "true" : "";
        let result = await orderService.getMemberOrdersForMobileAsync(
          this.queryInput
        );
        for (let i = 0; i < result.items.length; i++) {
          let o = result.items[i];
          o.status = "list-item-status" + o.orderStatusId;
          this.orders.push(result.items[i]);
        }

        this.queryInput.skipCount =
          this.queryInput.skipCount + result.items.length;

        this.finished = this.orders.length === result.totalCount;
      } catch (err) {
        return;
      } finally {
        this.loading = false;
        this.dataLoaded = true;
      }
    },
  },
  mounted() {
    let vm = this;
    window.onscroll = function () {
      let currentScrollTop = document.scrollingElement.scrollTop;
      if (currentScrollTop === 0 && vm.scrollTop > 1) {
        window.scrollTo(0, vm.scrollTop);
      } else {
        vm.scrollTop = currentScrollTop;
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    window.onscroll = null;
    next();
  },
};
</script>

<style scoped lang="scss">
.dataDiv {
  overflow: auto;
  position: fixed;
  width: 100%;
  height: calc(100vh - 95px);
}

.list-box {
  .van-cell__value {
    background-color: #fff;
    padding: 10px 0px;
    display: flex;
    justify-content: space-between;
    border-radius: 5px;
    box-shadow: 0px 0px 20px -2px #c5c0c0;
    .list-item-icon {
      margin: 2px 0px;
      width: 5px;
      background-color: #d9b2b3;
    }
    .list-item-body {
      width: calc(100% - 23px);
      position: relative;

      .list-item-title {
        font-weight: bold;
        padding-bottom: 7px;
        border-bottom: 1px dotted #dbdbdb;
      }
      ul li {
        display: flex;
        align-items: flex-end;
        padding-top: 2px;
        .ul-li-label {
          width: 55px;
          text-align-last: justify;
          text-align: justify;
          text-justify: distribute-all-lines; // 这行必加，兼容ie浏览bai器
          padding-right: 3px;
        }
        .ul-li-vmodel {
          width: calc(100% - 115px);
        }
      }

      .list-item-status {
        position: absolute;
        right: 18px;
        bottom: 6px;
        font-weight: bold;
        color: #bebebe;
      }

      .list-item-status3 {
        color: #4ab09a;
      }

      .list-item-status99 {
        color: #810102;
      }
    }
  }
  /deep/.van-cell::after {
    border-bottom: none;
  }
}
</style>
